module.exports = __webpack_public_path__ + "img/ecommerce.c7672ea6.jpg";